//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { commonApi } from '@/common/index';
  import loadMore from '@/common/components/load-more/index.vue'
  export default {
    components: { loadMore },
    data() {
      return {
        problemLists: []
      }
    },
    computed: {},
    created() {
      this._getList()
    },
    methods: {
      handleService({
        id,
        name
      }) {
        this.$router.push({
          path: '/Service/problems/details',
          query: {
            id,
            name
          }
        })
      },

      _getList() {
        commonApi.HELP.getArticleType().then((data) => {
          this.problemLists = data
        }).catch((err) => {})
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build800/views/Service/Problems/problems.vue